<template>
  <div class="flex h-screen text-white bg-[#120F14]">
    <!-- Sidebar -->
    <sidebar-element
      v-if="loading == false"
      class="h-screen sticky top-0"
    ></sidebar-element>

    <!-- Main Content -->
    <div id="main-scroll-container" ref="mainScroll" class="flex-1 flex flex-col overflow-y-auto overflow-x-hidden">
      <!-- Navbar -->
      <navbar-element
        v-if="loading == false"
        v-on:logout="handleLogout()"
      ></navbar-element>

      <!-- Loading Screen -->
      <loading-element v-if="loading == true"></loading-element>

      <!-- Page Content -->
      <router-view v-if="loading == false"></router-view>

      <!-- Footer -->
      <footer-element v-if="loading == false"></footer-element>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NavbarElement from "../components/NavbarElementUpdated.vue";
import FooterElement from "../components/FooterElementUpdated.vue";
import LoadingElement from "../components/LoadingElement.vue";
import SidebarElement from "@/components/SidebarElement.vue";

export default {
  components: {
    FooterElement,
    NavbarElement,
    LoadingElement,
    SidebarElement,
  },
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    $route() {
      this.scrollToTop();
    },
  },
  methods: {
    handleLogout() {
      this.loading = true;

      this.$store.commit("UPDATE_USER", null);
      this.$store.commit("UPDATE_USERNAME", null);
      localStorage.removeItem("vuex");
      localStorage.removeItem("maherco-access-token");
      this.isLogout = false;
      this.$router.replace("/");

      setTimeout(() => {
        this.loading = false;
      }, 2000);
    },
    scrollToTop() {
      this.$nextTick(() => {
        this.$refs.mainScroll?.scrollTo({ top: 0, behavior: "smooth" });
      });
    },
  },
  mounted() {
    const accessToken = this.$route.query.accessToken;
    if (accessToken != null || accessToken != undefined) {
      this.loading = true;
      axios
        .get(process.env.VUE_APP_BASE_API + "/api/users/me", {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          if (res) {
            const user = res.data.user;
            // const picUrl = `https://cdn.discordapp.com/avatars/${user.discordId}/${user.profileImage}.png`;
            const picUrl = res.data.user.profileImage;

            localStorage.setItem("maherco-access-token", accessToken);

            this.$store.commit("UPDATE_USER", user);
            
            this.$store.commit("UPDATE_USERNAME", user.username);
            this.$store.commit("UPDATE_AVATAR", { avatar: picUrl });

            setTimeout(() => {
              this.loading = false;
              this.$router.replace("/profile");
            }, 2000);
          }
        });
    }
  },
};
</script>

<style scoped></style>
